var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iconBubble",on:{"click":function($event){return _vm.onClick()}}},[_c('div',{staticClass:"bubble"},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }